import { Box, Flex } from '@chakra-ui/react';
import { Button } from '@kula-ai/components';
import { KText } from '@/ui-library/components/text';
import { KSelect } from '@/ui-library/components/molecules/KSelect';
import { SCHEDULE_AI_COPY } from '../../constants';

const COPY = SCHEDULE_AI_COPY;

const FALLBACK_TIMING_OPTIONS = [
  { value: 'immediately', label: 'Now (Immediately)' },
];

export const TimingSection = ({
  timing,
  setTiming,
  setCustomSchedule,
  scheduleDisplayInCandidateTimezone,
  candidateCurrentTimeLine,
  hasCandidateTimezone,
  missingTimezoneMessage,
  customSchedulePastError,
  timingOptions = FALLBACK_TIMING_OPTIONS,
  onOpenCustomDateModal,
}) => (
  <Box mb="20px">
    <KText variant="heading_4">{COPY.timingLabel}</KText>
    <Box mt="12px">
      <KSelect
        options={timingOptions}
        value={timingOptions.find((opt) => opt.value === timing)}
        onChange={(opt) => {
          const val = opt?.value;
          setTiming(val);
          if (val !== 'custom') setCustomSchedule(null);
        }}
        placeholder="Select timing"
      />
      {timing !== 'immediately' &&
        timing !== 'custom' &&
        scheduleDisplayInCandidateTimezone && (
          <KText fontSize="13px" color="#6D659D" mt="8px">
            {COPY.currentTimeForCandidate}: {scheduleDisplayInCandidateTimezone}
          </KText>
        )}
      {timing === 'custom' && (
        <Flex mt="12px" flexDir="column" gap="8px">
          {scheduleDisplayInCandidateTimezone ? (
            <Flex alignItems="center" gap="8px" flexWrap="wrap">
              <KText fontSize="13px" color="#6D659D">
                {COPY.currentTimeForCandidate}:{' '}
                {scheduleDisplayInCandidateTimezone}
              </KText>
              <Button
                type="button"
                variant="quaternary"
                size="sm"
                onClick={onOpenCustomDateModal}
              >
                Change
              </Button>
            </Flex>
          ) : (
            <Button
              type="button"
              variant="tertiary"
              size="sm"
              onClick={onOpenCustomDateModal}
            >
              {COPY.selectDateAndTime}
            </Button>
          )}
          {customSchedulePastError && (
            <KText fontSize="13px" color="red.500" mt="4px">
              {COPY.customScheduleInPast}
            </KText>
          )}
        </Flex>
      )}
      {!hasCandidateTimezone && (
        <KText fontSize="13px" color="#6D659D" mt="8px">
          {missingTimezoneMessage}
        </KText>
      )}
      {hasCandidateTimezone &&
        candidateCurrentTimeLine &&
        !scheduleDisplayInCandidateTimezone && (
          <KText fontSize="13px" color="#6D659D" mt="8px">
            {candidateCurrentTimeLine}
          </KText>
        )}
    </Box>
  </Box>
);
